<template #default>
  <a-input
    :value="props.value?.typ"
    @update:value="onChange"
    placeholder="e.g. Common Stock"
    allow-clear
  />
</template>

<script setup>
import { defineEmits, defineProps } from 'vue'

// Edits SecurityInfo.securityType.typ (db column SecType),
// securityType may be null when loaded from db.
const props = defineProps(['value'])
const emit = defineEmits(['update:value'])

const onChange = (val) => {
  const typ = val?.trim() ? val.trim() : null
  emit('update:value', { ...(props.value || {}), typ })
}
</script>
